import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SubtitlesOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"subtitles_off"}/>
}
